import React, { useEffect, useState } from 'react';
import { Button, Spinner, OverlayTrigger, Tooltip, Row } from 'react-bootstrap';
import MonitoringProjectsTable from './MonitoringProjectsTable';
import { PickList } from 'primereact/picklist';
import { DownloadFile } from 'icone/index';
import {
  getProjects,
  postMonitoringProjects,
  getMonitorableProjects,
  getMonitoringProjects,
} from '@lib/api';
import { DangerToast, SuccessToast } from 'components/GlobalToastList';
import { exportCreatedMonitoringExcel } from '@lib/api/index';

// const messages = [
//   'Individuando i progetti da monitorare',
//   'Predisponendo i progetti',
//   'Preparando la lista',
// ];

const MonitoringProjectsCTA = () => {
  const [source, setSource] = useState([]);
  const [target, setTarget] = useState([]);
  const [monitorableProjects, setMonitorableProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMonitoringLoading, setIsMonitoringLoading] = useState(false);
  const [messageIndex, setMessageIndex] = useState(0);
  const [showMessage, setShowMessage] = useState(true);
  const [monitoredProjects, setMonitoredProjects] = useState([]);
  const [monitoringGroupId, setMonitoringGroupId] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);

      try {
        // const retrievedProjects = await getProjects();
        const retrievedProjects = await getMonitorableProjects();
        const filteredProjects = retrievedProjects
          // .filter((project) => project.status === 'SUBMITTED' && !!!project?.isMonitoring)
          .map((project) => ({
            clientId: project.clientId,
            requestId: project.requestId,
            rating:
              project.esgratings
                ?.filter((el) => el.type === 'total')
                ?.map((total) => total.rating)
                ?.join(', ') || 'N/A',
            projectId: project.id,
          }));

        setMonitorableProjects(filteredProjects);
      } catch (error) {
        console.error('Errore nel recupero dei progetti:', error);
        // opzionale: setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  useEffect(() => {
    if (monitorableProjects.length > 0) setSource(monitorableProjects);
  }, [monitorableProjects]);

  const itemTemplate = (project) => {
    return (
      <div className='flex flex-wrap p-2 align-items-center gap-3'>
        <div className='flex-1 flex flex-column gap-2'>
          <span>NDG: </span>
          <span className='font-weight-bold'>{project.clientId}</span>
          <div className='flex align-items-center gap-2'>
            <span>N.Rapporto: </span>
            <span className='font-weight-bold'>{project.requestId}</span>
          </div>
        </div>
        <span>Rating ESG: </span>
        <span className='font-weight-bold'>{project.rating}</span>
      </div>
    );
  };

  // const startFakeApiCall = () => {
  //   if (monitoredProjects.length > 0) return;

  //   setLoading(true);
  //   setMessageIndex(0);
  //   setShowMessage(true);

  //   let step = 0;
  //   const interval = setInterval(() => {
  //     setShowMessage(false);
  //     setTimeout(() => {
  //       setMessageIndex((prev) => prev + 1);
  //       setShowMessage(true);
  //     }, 300);
  //     step++;
  //     if (step >= messages.length - 1) clearInterval(interval);
  //   }, 1600);
  //   if (!monitorableProjects || monitorableProjects.length === 0) {
  //     setLoading(false);
  //     DangerToast('Attenzione', 'Errore nel ricercare potenziali progetti da monitorare');
  //     return;
  //   }
  //   setTimeout(() => {
  //     setLoading(false);
  //     setMessageIndex(0);

  //     const { picked, rest } = pickRandom(monitorableProjects, 10);

  //     setTarget(picked);
  //     setSource(rest);
  //   }, 5000);
  // };

  const startFakeApiCallMonitoring = () => {
    if (monitoredProjects.length > 0) return;
    setIsMonitoringLoading(true);
    setMessageIndex(0);
    setShowMessage(true);

    setTimeout(() => {
      setIsMonitoringLoading(false);
      setMessageIndex(0);
      setMonitoredProjects(target); // salva nello stato
    }, 5000);
  };
  // Abilitare una volta pronto il BE
  const submitMonitoring = async () => {
    if (target.length === 0) return;

    setLoading(true);
    const selectedProjectsArray = target.map((item) => item.projectId);

    try {
      const resultOfMonitoringCall = await postMonitoringProjects({ ids: selectedProjectsArray });
      SuccessToast('Operazione conclusa', 'Monitoraggio avviato correttamente');

      getProjectsForTable(resultOfMonitoringCall.monitoringGroup);
    } catch (error) {
      DangerToast('Attenzione', 'Errore nella creazione del monitoraggio');
    } finally {
      setLoading(false);
    }
  };

  const getProjectsForTable = async (monitoringId) => {
    setIsMonitoringLoading(true);
    try {
      const projects = await getMonitoringProjects(monitoringId);
      setMonitoredProjects(
        projects.map((project) => ({
          clientId: project.clientId,
          requestId: project.requestId,
          rating:
            project.esgratings
              ?.filter((el) => el.type === 'total')
              ?.map((total) => total.rating)
              ?.join(', ') || 'N/A',
          projectId: project.id,
        })),
      );
      setMonitoringGroupId(monitoringId);
    } catch (error) {
      DangerToast('Attenzione', 'Errore nel recupero dei progetti monitorati');
    } finally {
      setIsMonitoringLoading(false);
    }
  };

  const onChange = (event) => {
    setSource(event.source);
    setTarget(event.target);
  };
  const downloadTooltip = (props) => <Tooltip {...props}>Download Excel</Tooltip>;
  return (
    <div className='text-center'>
      <p>Questa sezione permette di avviare un monitoraggio da selezione dei progetti.</p>

      {/* {loading ? (
        <div className='mt-4'>
          <div
            style={{
              opacity: showMessage ? 1 : 0,
              transition: 'opacity 0.3s ease-in-out',
              minHeight: '2rem',
              fontWeight: 'bold',
            }}>
            {messages[messageIndex]}
          </div>
          <Spinner animation='border' role='status' className='my-3'>
            <span style={{ visibility: 'hidden' }}>Loading...</span>
          </Spinner>
        </div>
      ) : (
        <div className='d-flex justify-content-center my-4'>
          <Button
            className='btn btn-primary'
            onClick={startFakeApiCall}
            disabled={monitoredProjects.length > 0 || isMonitoringLoading}>
            Avvia individuazione progetti
          </Button>
        </div>
      )} */}
      {loading && (
        <div className='mt-4'>
          <Spinner animation='border' role='status' className='my-3'>
            <span style={{ visibility: 'hidden' }}>Loading...</span>
          </Spinner>
        </div>
      )}
      {source.length === 0 && (
        <div className='my-4'>
          <p className='font-weight-bold'>Nessun progetto da poter monitorare in questo momento.</p>
        </div>
      )}
      {(source.length > 0 || target.length > 0) && (
        <div className='my-4'>
          <PickList
            source={source}
            target={target}
            onChange={onChange}
            itemTemplate={itemTemplate}
            filter
            filterBy='clientId,requestId,rating'
            breakpoint='1400px'
            sourceHeader='Disponibili'
            targetHeader='Selezionati'
            sourceStyle={{ height: '30rem' }}
            targetStyle={{ height: '30rem' }}
          />

          <div className='d-flex justify-content-center mt-4'>
            <Button
              className='btn btn-primary'
              onClick={submitMonitoring}
              disabled={monitoredProjects.length > 0 || isMonitoringLoading || target.length === 0}>
              Avvia Monitoraggio
            </Button>
          </div>
        </div>
      )}
      {isMonitoringLoading ? (
        <div className='d-flex justify-content-center align-items-center gap-1'>
          <Spinner animation='border' role='status' />
          <span>Caricamento...</span>
        </div>
      ) : null}
      {monitoredProjects.length > 0 && !isMonitoringLoading && (
        <div>
          <div className='d-flex justify-content-end'>
            <OverlayTrigger placement='top' overlay={downloadTooltip}>
              <Button
                variant='info'
                onClick={() => exportCreatedMonitoringExcel(monitoringGroupId)}
                aria-label='Download Excel'
                className='ml-2 lineheight-initial'
                disabled={isMonitoringLoading}>
                <Row
                  className='align-items-center justify-content-center'
                  style={{ padding: '0.25rem 0.7rem' }}>
                  {isMonitoringLoading ? (
                    'Loading…'
                  ) : (
                    <DownloadFile width='23px' className='light-color m-0' />
                  )}
                </Row>
              </Button>
            </OverlayTrigger>
          </div>
          <MonitoringProjectsTable rowData={monitoredProjects} />
        </div>
      )}
    </div>
  );
};

export default MonitoringProjectsCTA;
